// The render service's legal documents (the boss's set, 2026-11-02: Terms, Privacy Notice, Refund and
// Digital Delivery Policy, Cookie Notice). Their text is in render-legal.component.html, exactly as
// delivered. The platform's older Terms of Service and Privacy Policy (/legal/terms-of-service,
// /legal/privacy-policy) stay for memberships and the iOS app — the App Store listing and the sign-in
// consent screens link there.

export type RenderLegalDocId = 'terms' | 'privacy' | 'refunds' | 'cookies';

export interface RenderLegalDoc {
  id: RenderLegalDocId;
  title: string;
  // Its name in the documents' row and the footers.
  label: string;
  url: string;
}

// The Terms name the refund policy by this address (§4), so the addresses are the files' names.
export const RENDER_LEGAL_DOCS: ReadonlyArray<RenderLegalDoc> = [
  { id: 'terms', title: 'Rendering Service Terms', label: 'Terms', url: '/legal/rendering-terms' },
  { id: 'privacy', title: 'Rendering Service Privacy Notice', label: 'Privacy', url: '/legal/rendering-privacy' },
  { id: 'refunds', title: 'Refund and Digital Delivery Policy', label: 'Refunds', url: '/legal/refund-delivery-policy' },
  { id: 'cookies', title: 'Cookie and Similar Technologies Notice', label: 'Cookies', url: '/legal/cookies' },
];

export function renderLegalUrl(id: RenderLegalDocId): string {
  return RENDER_LEGAL_DOCS.find((doc) => doc.id === id)!.url;
}
